import { render } from "./CreateWarikanModal.vue?vue&type=template&id=23a5b568&scoped=true"
import script from "./CreateWarikanModal.vue?vue&type=script&lang=js"
export * from "./CreateWarikanModal.vue?vue&type=script&lang=js"

import "./CreateWarikanModal.vue?vue&type=style&index=0&id=23a5b568&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a5b568"]])

export default __exports__